import axios from "axios";
import {ApiResponse} from "@interface/common";
import {User} from "@interface/master/UserManagementIF";
import {
    TemperatureHumidity,
    SensorStatusData,
    DashboardDetailItem,
    DashboardDetailParam,
    MarkerListItem,
    BatteryListItem,
    AlarmInfoItem,
    AlarmInfo,
    DashboardDetailSearchConditions
} from "@interface/dashboard/Dashboard";

export const getWeatherData = async () => {
    const {data} = await axios.get<ApiResponse<TemperatureHumidity>>('/api/dashboard/weather-data', {headers:{showLoading:false}});
    return data;
};

export const getSensorListData = async () => {
    const {data} = await axios.get<ApiResponse<SensorStatusData>>('/api/dashboard/sensor-data');
    return data;
};

export const getMakerListData = async () => {
    const {data} = await axios.get<ApiResponse<MarkerListItem[]>>('/api/dashboard/marker-data');
    return data;
};

export const getBatteryListData = async () => {
    const {data} = await axios.get<ApiResponse<BatteryListItem[]>>('/api/dashboard/battery-data');
    return data;
};

//검색조건
export const getDashboardDetailSearchConditions = async () => {
    const {data} = await axios.get<ApiResponse<DashboardDetailSearchConditions>>('/api/dashboard/detail-search-conditions');
    return data;
};

export const getDashboardDetail = async (param:DashboardDetailParam) => {
    const {data} = await axios.get<ApiResponse<DashboardDetailItem[]>>('/api/dashboard/detail-data',{params:param});
    return data;
};

export const getAlarmData = async () => {
    const {data} = await axios.get<ApiResponse<AlarmInfo>>('/api/dashboard/alarm-data');
    return data;
};